import { createClient } from "@supabase/supabase-js";

const supabaseUrl =
  import.meta.env.VITE_SUPABASE_URL || "https://placeholder.supabase.co";
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY || "placeholder_key";

// In dev mode, we'll use placeholder values
const isDevMode = import.meta.env.VITE_DEV_MODE === "true";

if (
  !isDevMode &&
  (!supabaseUrl ||
    !supabaseKey ||
    supabaseUrl === "https://placeholder.supabase.co")
) {
  console.warn(
    "Missing or placeholder Supabase environment variables. Authentication will work in dev mode only.",
  );
}

export const supabase = createClient(supabaseUrl, supabaseKey);
